<template>
  <div>
    <div
      id="content"
      v-on:keyup="keymonitor"
      class="content animated slideInRight delay-1s"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Resetar senha de {{ user.name }}</div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <form id="form">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="description">
                            <span class="required">*</span> Nova senha:
                          </label>
                          <input
                            type="password"
                            minlength="6"
                            v-on:keyup="keymonitor"
                            maxlength="12"
                            class="form-control"
                            v-model="user.new_password"
                            autocomplete="new-password"
                          />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="description">
                            <span class="required">*</span> Corfirme a nova
                            senha:
                          </label>
                          <input
                            type="password"
                            minlength="6"
                            v-on:keyup="keymonitor"
                            maxlength="12"
                            class="form-control"
                            v-model="user.password_confirmation"
                            autocomplete="new-password"
                          />
                        </div>
                      </div>
                    </div>
                    <div v-if="comparePassword()" class="left">
                      <div class="alert alert-danger col-md-3" role="alert">
                        <strong>As senhas não podem ser diferentes!</strong>
                      </div>
                    </div>
                    <div v-if="activatedCaps" class="left">
                      <label>
                        <span class="caps"
                          >CapsLock Ativo
                          <i
                            class="fa fa-arrow-circle-up"
                            aria-hidden="true"
                          ></i
                        ></span>
                      </label>
                    </div>
                    <hr />
                    <div class="block text-right">
                      <a class="btn btn-add" @click="save">
                        Salvar
                        <i class="fa fa-save"></i>
                      </a>
                      <router-link to="/users" class="btn btn-back">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user: {
        name: ["name"],
        new_password: {},
        password_confirmation: {},
      },
      activatedCaps: false,
    };
  },
  mounted() {
    const self = this;
    let id = self.$route.params.id;
    console.log("id", id);
    if (id) {
      self.getUsers(id);
    }
  },
  methods: {
    makeFormData: function () {
      const self = this;
      let fd = new FormData();
      fd.append("new_password", self.user.new_password);
      fd.append("password_confirmation", self.user.password_confirmation);
      fd.append("id", self.$route.params.id);

      return fd;
    },
    save: function () {
      const self = this;
      let api = self.$store.state.api + "user-reset-password";

      let fd = self.makeFormData();

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/users");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    keymonitor() {
      if (event.getModifierState && event.getModifierState("CapsLock")) {
        this.activatedCaps = true;
      } else {
        this.activatedCaps = false;
      }
      console.log(this.activatedCaps);
    },
    comparePassword: function () {
      if (this.user.new_password != this.user.password_confirmation || null)
        return [];
    },
    getUsers: function (id) {
      const self = this;
      const api = self.$store.state.api + "users/" + id;

      self.$http
        .get(api)
        .then((response) => {
          self.user = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
};
</script>

<style>
.comparePassword {
  color: rgb(241, 0, 0);
  font: bold;
  font-size: 20px;
}
.caps {
  color: black;
  font: bold;
  text-align: right;
  font-size: 20px;
}
.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important ;
}
</style>


// WEBPACK FOOTER //
// src/components/User/Reset.vue